module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "om-page-heading"
  }, [_vm._v("\n    " + _vm._s(_vm.isNew ? _vm.$tr('Dodawanie nowego sklepu', 'ShopSettings') : _vm.$tr('Edytuj dane sklepu', 'ShopSettings')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "om-form",
    attrs: {
      "data-vv-scope": "shop-form"
    }
  }, [_c('div', {
    staticClass: "om-form__group"
  }, [_c('label', {
    attrs: {
      "for": "in-name"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Nazwa sklepu:', 'ShopSettings')))]), _vm._v(" "), _c('div', {
    staticClass: "om-form__input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.name),
      expression: "shop.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: /^[\w żźćńółęąśŻŹĆĄŚĘŁÓŃ.,\-]*$/
        }
      }),
      expression: "{ rules: { required: true, regex: /^[\\w żźćńółęąśŻŹĆĄŚĘŁÓŃ.,\\-]*$/} }"
    }],
    attrs: {
      "title": _vm.$tr('nazwa sklepu', 'ShopSettings'),
      "id": "in-name",
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.shop.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shop, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [(_vm.errors.has('name')) ? _c('div', {
    staticClass: "om-error om-form__group"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "om-form__group flex"
  }, [_c('label', {
    attrs: {
      "for": "in-address-street"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Adres sklepu:', 'ShopSettings')))]), _vm._v(" "), _c('div', {
    staticClass: "om-form__input-wrap om-form__input-wrap--street fg-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.address.street),
      expression: "shop.address.street"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: /^[\w żźćńółęąśŻŹĆĄŚĘŁÓŃ.,\-]*$/
        }
      }),
      expression: "{ rules: { required: true, regex: /^[\\w żźćńółęąśŻŹĆĄŚĘŁÓŃ.,\\-]*$/} }"
    }],
    attrs: {
      "title": _vm.$tr('adres sklepu', 'ShopSettings'),
      "id": "in-address-street",
      "type": "text",
      "name": "address_street"
    },
    domProps: {
      "value": (_vm.shop.address.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shop.address, "street", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "om-form__input-wrap om-form__input-wrap--house"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.address.house),
      expression: "shop.address.house"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          regex: /^[0-9A-z]+$/
        }
      }),
      expression: "{ rules: { regex: /^[0-9A-z]+$/} }"
    }],
    attrs: {
      "title": _vm.$tr('nr budynku', 'ShopSettings'),
      "id": "in-address-house",
      "type": "text",
      "name": "address_house"
    },
    domProps: {
      "value": (_vm.shop.address.house)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shop.address, "house", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "om-slash"
  }), _vm._v(" "), _c('div', {
    staticClass: "om-form__input-wrap om-form__input-wrap--flat"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.address.flat),
      expression: "shop.address.flat"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          regex: /^[0-9A-z]+$/
        }
      }),
      expression: "{ rules: { regex: /^[0-9A-z]+$/} }"
    }],
    attrs: {
      "title": _vm.$tr('nr lokalu', 'ShopSettings'),
      "id": "in-address-flat",
      "type": "text",
      "name": "address_flat"
    },
    domProps: {
      "value": (_vm.shop.address.flat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shop.address, "flat", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [(_vm.errors.has('address_street')) ? _c('div', {
    staticClass: "om-form__group om-error"
  }, [_vm._v(_vm._s(_vm.errors.first('address_street')))]) : (_vm.errors.has('address_house')) ? _c('div', {
    staticClass: "om-form__group om-error"
  }, [_vm._v(_vm._s(_vm.errors.first('address_house')))]) : (_vm.errors.has('address_flat')) ? _c('div', {
    staticClass: "om-form__group om-error"
  }, [_vm._v(_vm._s(_vm.errors.first('address_flat')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "om-form__group"
  }, [_c('label', {
    attrs: {
      "for": "in-address-postcode"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Kod pocztowy:', 'ShopSettings')))]), _vm._v(" "), _c('div', {
    staticClass: "om-form__input-wrap om-form__input-wrap--postcode"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.address.postcode),
      expression: "shop.address.postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: /^([0-9]{2}-[0-9]{3})$/
        }
      }),
      expression: "{ rules: { required: true, regex: /^([0-9]{2}-[0-9]{3})$/} }"
    }],
    attrs: {
      "title": _vm.$tr('kod pocztowy', 'ShopSettings'),
      "id": "in-address-postcode",
      "type": "text",
      "name": "address_postcode"
    },
    domProps: {
      "value": (_vm.shop.address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shop.address, "postcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "om-form__group om-form__group--city"
  }, [_c('label', {
    attrs: {
      "for": "in-address-city"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Miasto:', 'ShopSettings')))]), _vm._v(" "), _c('div', {
    staticClass: "om-form__input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.address.city),
      expression: "shop.address.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: /^[\w żźćńółęąśŻŹĆĄŚĘŁÓŃ.,]*$/
        }
      }),
      expression: "{ rules: { required: true, regex: /^[\\w żźćńółęąśŻŹĆĄŚĘŁÓŃ.,]*$/} }"
    }],
    attrs: {
      "title": _vm.$tr('miasto', 'ShopSettings'),
      "id": "in-address-city",
      "type": "text",
      "name": "address_city"
    },
    domProps: {
      "value": (_vm.shop.address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shop.address, "city", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [(_vm.errors.has('address_postcode')) ? _c('div', {
    staticClass: "om-form__group om-error"
  }, [_vm._v(_vm._s(_vm.errors.first('address_postcode')))]) : (_vm.errors.has('address_city')) ? _c('div', {
    staticClass: "om-form__group om-error"
  }, [_vm._v(_vm._s(_vm.errors.first('address_city')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "om-form__group"
  }, [_c('label', {
    attrs: {
      "for": "in-email"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Adres e-mail:', 'ShopSettings')))]), _vm._v(" "), _c('div', {
    staticClass: "om-form__input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.email),
      expression: "shop.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "title": _vm.$tr('adres e-mail', 'ShopSettings'),
      "id": "in-email",
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.shop.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shop, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [(_vm.errors.has('email')) ? _c('div', {
    staticClass: "om-error om-form__group"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "om-form__group"
  }, [_c('label', {
    attrs: {
      "for": "in-password"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Hasło:', 'ShopSettings')))]), _vm._v(" "), _c('div', {
    staticClass: "om-form__input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "title": _vm.$tr('hasło', 'ShopSettings'),
      "id": "in-password",
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [(_vm.errors.has('password')) ? _c('div', {
    staticClass: "om-error om-form__group"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "om-form__group"
  }, [_c('label', {
    attrs: {
      "for": "in-confirmation"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Powtórz hasło:', 'ShopSettings')))]), _vm._v(" "), _c('div', {
    staticClass: "om-form__input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmation),
      expression: "confirmation"
    }],
    attrs: {
      "title": _vm.$tr('powtórz hasło', 'ShopSettings'),
      "id": "in-confirmation",
      "type": "password",
      "name": "confirmation"
    },
    domProps: {
      "value": (_vm.confirmation)
    },
    on: {
      "blur": function($event) {
        _vm.confirmationBlurred = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmation = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [(_vm.errors.has('confirmation')) ? _c('div', {
    staticClass: "om-error om-form__group"
  }, [_vm._v(_vm._s(_vm.errors.first('confirmation')))]) : (_vm.password !== _vm.confirmation) ? _c('div', {
    staticClass: "om-error om-form__group"
  }, [_vm._v(_vm._s(_vm.$tr('Hasła do siebie nie pasują', 'ShopSettings')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "om-form__group"
  }, [_c('button', {
    staticClass: "om-btn om-form__submit",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pushShop.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$tr('Zapisz zmiany', 'ShopSettings')) + "\n      ")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3396ec90","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/ShopSettings.vue
// module id = 279
// module chunks = 1